import React from 'react';
import { useGarageUrl } from '../../garage';

const StorageImage = ({ src, alt = '', style, className, onClick, ...props }) => {
  const url = useGarageUrl(src);
  if (!url) return null;
  return (
    <img
      src={url}
      alt={alt}
      style={style}
      className={className}
      onClick={onClick}
      {...props}
    />
  );
};

export default StorageImage;
